import React from 'react';

import './dropdownList.css';

const STARTSWITH_FIELDS = [
  'pickup_postcode',
  'delivery_postcode',
  'establishment_postcode',
  'billing_postcode',
];

export default function DropdownList({
  isLoading,
  data,
  setData,
  dataType,
  columnName = '',
  handleClick,
  multiSelectable = false,
  handleValidateSelection = null,
}) {
  const [inputValue, setInputValue] = React.useState('');

  const stringValues = data.filter(value => typeof value.value === 'string');
  const hasStringValues = stringValues.length > 0;
  const useStartsWith = STARTSWITH_FIELDS.includes(columnName);

  if (!isLoading && !hasStringValues) {
    return null;
  }

  return (
    <div className="dropdown-list-container">
      <input
        className="dropdown-list-button-input"
        type="text"
        placeholder="Rechercher..."
        value={inputValue}
        onChange={event => setInputValue(event.target.value)}
      />
      <ul className={`dropdown-list ${multiSelectable ? 'multi-selectable' : ''}`}>
        {isLoading ? (
          <li>Chargement...</li>
        ) : data.length === 0 ? (
          <li>Aucune valeur unique</li>
        ) : (
          <>
            {multiSelectable && (
              <div
                className="dropdown-list-item"
                onClick={() => {
                  setData(prevValues =>
                    prevValues.map(item => ({ ...item, selected: !item.selected }))
                  );
                }}
              >
                {multiSelectable && (
                  <input
                    className="dropdown-list-item-checkbox"
                    type="checkbox"
                    checked={data.every(item => item.selected)}
                    readOnly
                  />
                )}
                <li> --- </li>
              </div>
            )}
            {data
              .filter(value => {
                if (typeof value.value !== 'string') return false;
                const search = inputValue.toLowerCase();
                const val = value.value.toLowerCase();
                return useStartsWith ? val.startsWith(search) : val.includes(search);
              })
              .map((value, index) => (
                <div
                  key={index}
                  className="dropdown-list-item"
                  onClick={() => {
                    setData(prevValues =>
                      prevValues.map(item =>
                        item === value ? { ...item, selected: !item.selected } : item
                      )
                    );
                  }}
                >
                  {multiSelectable && (
                    <input
                      className="dropdown-list-item-checkbox"
                      type="checkbox"
                      checked={value.selected}
                      readOnly
                    />
                  )}
                  <li
                    key={index}
                    onClick={() => {
                      if (!multiSelectable) {
                        handleClick(value.value);
                      }
                    }}
                  >
                    {dataType === 'boolean' ? (value.value ? 'Oui' : 'Non') : value.value}
                  </li>
                </div>
              ))}
          </>
        )}
      </ul>
      {multiSelectable && (
        <button
          className="dropdown-list-button-input"
          type="button"
          onClick={handleValidateSelection}
        >
          Valider
        </button>
      )}
    </div>
  );
}
